import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import config from "../../config/config";
import withRouter from "../../components/Common/withRouter";

class CreateCtaSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "CTA Section", link: "/cta-section" },
        { title: "Create CTA Section", link: "#" },
      ],
      title: "",
      subtitle: "",
      buttonName: "",
      navigationUrl: "",
      rightImage: null,
      rightImagePreview: null,
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({ rightImage: file, rightImagePreview: URL.createObjectURL(file) });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        title: this.state.title,
        subtitle: this.state.subtitle,
        buttonName: this.state.buttonName,
        navigationUrl: this.state.navigationUrl,
        rightImage: this.state.rightImage,
      };

      const response = await fetch(`${config.API_BASE_URL}/cta-section`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("CTA Section created:", data);
        this.props.router.navigate("/cta-section");
      } else {
        alert(data.message || "Failed to create CTA section");
      }
    } catch (error) {
      console.error("Error creating CTA section:", error);
      alert("Error creating CTA section");
    }
  };

  handleCancel = () => {
    this.props.router.navigate("/cta-section");
  };

  render() {
    return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Create CTA Section"
            breadcrumbItems={this.state.breadcrumbItems}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Form onSubmit={this.handleSubmit}>
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label>Title</Label>
                          <Input
                            type="text"
                            name="title"
                            placeholder="Enter CTA title"
                            value={this.state.title}
                            onChange={this.handleChange}
                            required
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label>Subtitle</Label>
                          <Input
                            type="text"
                            name="subtitle"
                            placeholder="Enter CTA subtitle"
                            value={this.state.subtitle}
                            onChange={this.handleChange}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label>Button Name</Label>
                          <Input
                            type="text"
                            name="buttonName"
                            placeholder="Enter button text"
                            value={this.state.buttonName}
                            onChange={this.handleChange}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label>Navigation URL</Label>
                          <Input
                            type="text"
                            name="navigationUrl"
                            placeholder="/tour-details"
                            value={this.state.navigationUrl}
                            onChange={this.handleChange}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                    <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">Image</Label>
                            <Input
                              type="file"
                              className="form-control"
                              onChange={this.handleImageChange}
                              accept="image/*"
                              required
                            />
                            {this.state.rightImagePreview && (
                              <img
                                src={this.state.rightImagePreview}
                                alt="Image Preview"
                                className="img-fluid mt-2"
                                style={{ maxHeight: "200px" }}
                              />
                            )}
                          </div>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col className="d-flex justify-content-end">
                        <Button type="submit" color="primary" className="me-2">
                          Create CTA Section
                        </Button>
                        <Button
                          type="button"
                          color="secondary"
                          onClick={this.handleCancel}
                        >
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withRouter(CreateCtaSection);
